import {getJSON, postData} from "./API";
import {getRequest, postRequest} from "./AxiosConfig";

const apiMapping = "api/user";

export async function getAllUsers() {
    return await getJSON(apiMapping + "/all");
}

export async function getUserById(userId) {
    return await getJSON(apiMapping + "/find/" + userId);
}

export async function getMyUser() {
    return await getJSON(apiMapping + "/find/me");
}

export async function getPostLoginHandle(idToken) {
    return await postRequest("/user/login/handle", null, {idToken:idToken});
}

export async function signOut() {
    return await getRequest("/auth/logout")
}

export async function getUserInfo() {
    return await getRequest("/user/find/me");
}

export async function createUserFeedback(rating, feedback) {
    return await postData("api/user/feedback", {
        feedback: feedback,
        rating: rating
    });
}